// extracted by mini-css-extract-plugin
module.exports = {"booking":"Booking_booking__1JBsZ","icon-naver":"Booking_icon-naver__3BA0r","icon-kakao":"Booking_icon-kakao__34i-y","icon-phone":"Booking_icon-phone__3RJ4r"};